module.exports = __webpack_public_path__ + "static/media/card3-min.32016f65.jpg";